import type React from 'react';

import { Card, CardBody } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

export const ActionCard: React.FC<React.ComponentProps<typeof Card>> = ({ className, children, ...props }) => {
	return (
		<Card className={cn('bg-background-base', className)} {...props}>
			<CardBody>{children}</CardBody>
		</Card>
	);
};
